import { render, staticRenderFns } from "./NotificationRecipients.vue?vue&type=template&id=f0f03190&"
import script from "./NotificationRecipients.vue?vue&type=script&lang=js&"
export * from "./NotificationRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports